import ActionTypes from '../constants/ActionTypes';

export const getTest = slug => ({
  type: ActionTypes.GET_TEST,
  slug,
});

export const getSolutionSet = (testId, isForced) => ({
  type: ActionTypes.GET_TEST_SOLUTIONSET,
  testId,
  isForced,
});

export const initTest = (
  userId,
  userType,
  testId,
  testSlug,
  showChecksModal = false,
  isInfraAllocated
) => ({
  type: ActionTypes.INIT_TEST,
  userId,
  userType,
  testId,
  testSlug,
  showChecksModal,
  isInfraAllocated,
});

export const startTest = (testId, testSlug) => ({
  type: ActionTypes.START_TEST,
  testId,
  testSlug,
});

export const continueTest = (inviteId, testSlug, testId) => ({
  type: ActionTypes.CONTINUE_TEST,
  inviteId,
  testSlug,
  testId,
});
export const getSection = (testId, isForce) => ({
  type: ActionTypes.GET_SECTIONS,
  testId,
  isForce,
});

export const getProblems = (testId, problemIds, problemSlugs) => ({
  type: ActionTypes.GET_PROBLEMS,
  testId,
  problemIds,
  // Optional: used as a fallback (especially for ADP flow) when id-based API returns empty.
  problemSlugs,
});
export const getProblemSolution = problemSlug => ({
  type: ActionTypes.GET_PROBLEM_SOLUTION,
  problemSlug,
});
export const getDesmondProblemSolution = problemSlug => ({
  type: ActionTypes.GET_DESMOND_PROBLEM_SOLUTION,
  problemSlug,
});
/*
  Todo:
    1. Action `SAVE_SOLUTION_NO_DEBOUNCE` is used in MCQ container src/components/ProblemTypes/MultipleChoice.js
    rename to `SAVE_MCQ_SOLUTION`
    2. Action `SAVE_SOLUTION` is used in SUB container
      src/components/Solution/Solution.js rename to `SAVE_SUBJECTIVE_SOLUTION`
    3. rename `saveSolution` to `saveMCQSolution`
    4. rename `saveSolutionNoDebounce` to `saveSubjectiveSolution`
*/
export const saveSolution = (
  solution,
  problemSlug,
  slug,
  isAutoSave = true,
  retryCallback
) => ({
  type: ActionTypes.SAVE_SOLUTION,
  problemSlug,
  solution,
  slug,
  isAutoSave,
  retryCallback,
});
export const saveSolutionNoDebounce = (
  solution,
  problemSlug,
  solutionSlug,
  retryCallback
) => ({
  type: ActionTypes.SAVE_SOLUTION_NO_DEBOUNCE,
  problemSlug,
  solution,
  solutionSlug,
  retryCallback,
});

export const createOrUpdateVideoSolution = (
  solution,
  problemSlug,
  solutionSlug,
  retryCallback
) => ({
  type: ActionTypes.CREATE_OR_UPDATE_VIDEO_SOLUTION,
  problemSlug,
  solution,
  solutionSlug,
  retryCallback,
});

export const submitTest = isForceSubmit => ({
  type: ActionTypes.SUBMIT_TEST,
  isForceSubmit,
});

export const getBookmarks = () => ({
  type: ActionTypes.GET_BOOKMARKS,
});

export const setBookmark = (problemSlug, status) => ({
  type: ActionTypes.SET_BOOKMARK,
  problemSlug,
  status,
});

export const submitSection = (solutionsetId, sectionSlug, forceSubmission) => ({
  type: ActionTypes.SUBMIT_SECTION,
  solutionsetId,
  sectionSlug,
  forceSubmission,
});

export const setAttemptedCount = problem => ({
  type: ActionTypes.SET_ATTEMPTS_COUNT,
  problem,
});

export const submitFeedback = payload => ({
  type: ActionTypes.SUBMIT_FEEDBACK,
  payload,
});

export const getFeedback = () => ({
  type: ActionTypes.GET_FEEDBACK,
});

export const uploadProblemAttachment = (
  file,
  solution,
  problemSlug,
  solutionSlug,
  retryCallback
) => ({
  type: ActionTypes.UPLOAD_ATTACHMENT_PROB,
  file,
  solution,
  problemSlug,
  solutionSlug,
  retryCallback,
});

export const submitAndEvaluate = payload => ({
  type: ActionTypes.SUBMIT_AND_EVALUATE_FBE,
  payload,
});

export const getAllSolutionRevisions = (problemSlug, solutionSlug) => ({
  type: ActionTypes.GET_ALL_REVISIONS,
  problemSlug,
  solutionSlug,
});

export const getServerTime = ({
  isInitialCall = false,
  isLastCall = false,
} = {}) => ({
  type: ActionTypes.GET_SERVER_TIME_AND_TRACKING_ID,
  isInitialCall,
  isLastCall,
});

export const adaptiveNextProblem = problemSlug => ({
  type: ActionTypes.ADAPTIVE_NEXT_PROBLEM,
  problemSlug,
});

export const fetchNextProblem = solutionSetId => ({
  type: ActionTypes.FETCH_NEXT_PROBLEM,
  solutionSetId,
});

export const reportIssue = payload => ({
  type: ActionTypes.REPORT_ISSUE,
  payload,
});

export const showReportDialog = payload => ({
  type: ActionTypes.SHOW_REPORT_ISSUE,
  payload,
});

export const hideReportDialog = () => ({
  type: ActionTypes.HIDE_REPORT_ISSUE,
});

export const clearLocalData = isTestStart => ({
  type: ActionTypes.CLEAR_LOCAL_DATA,
  isTestStart,
});

export const setSaveInProgress = (problemSlug, isInProgress) => ({
  type: ActionTypes.SET_SAVE_IN_PROGRESS,
  isInProgress,
  problemSlug,
});

export const clearSolution = (problemSlug, slug, clusterSlug) => ({
  type: ActionTypes.CLEAR_SOLUTION,
  problemSlug,
  slug,
  clusterSlug,
});

export const updateTestExpiryAndSessionState = values => ({
  type: ActionTypes.UPADTE_TEST_EXPIRY_AND_TEST_SESSION,
  ...values,
});

export const setTestEndTime = (assessmentId, currentTestEndTime) => ({
  type: ActionTypes.SET_TEST_END_TIME,
  payload: {
    assessmentId,
    currentTestEndTime,
  },
});

export const setSecureBrowser = status => ({
  type: ActionTypes.SECURE_BROWSER_STATUS,
  payload: status,
});

export const updateTestLiveStatus = testLiveStatus => ({
  type: ActionTypes.SET_TEST_LIVE_STATUS,
  payload: {
    testLiveStatus,
  },
});
